const locale = {
  availableIpCount: 'available IP(s)'
};
export default locale;